// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hu-6";
export var emphasizeQuantity = "_hu-3";
export var flatBottomCorners = "_hu-5";
export var productImage = "_hu-0";
export var quantityContainer = "_hu-2";
export var tooltip = "_hu-1";
export var wrapAndEllipsesOverflow = "_hu-4";